import { Component, OnInit, inject } from '@angular/core';
import {AuthService} from './core/auth/auth.service';
import {Observable} from 'rxjs';
import User from './core/auth/user';
import {ThemeService} from './core/theme/theme.service';

@Component({
    selector: 'zah-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  private authService = inject(AuthService);

  user$: Observable<User>;

  ngOnInit(): void {
    this.themeService.applyTheme();
    this.user$ = this.authService.getUser$();
  }
}
